
import Vue from 'vue';
import { autoTranslate } from '@/helpers/autoTranslate';

export default Vue.extend({
  props: {
    input: { type: Object, default: () => {} },
    data: { type: Object, default: () => {} },
    getVariable: { type: Function, default: () => () => {} },
    callFunction: { type: Function, default: () => () => {} },
    onChange: { type: Function, default: () => {} },
    parent: { type: Object, default: () => {} },
    groupItemKey: { type: Number, default: -1 }
  },
  computed: {
    autoTranslatedLabel: function(): string {
      return autoTranslate(this.input.label);
    },
    resolvedFormulaValue: function () : string {
      return this.retrieveFormulaValue(this.input.formula)
    },
    labelValue: function() : string {
      let labelValue: any = '';
      if(this.input.labelType==='formula') {
        labelValue = this.parent._checkFilter(this.input, this.resolvedFormulaValue, this.retrieveFormulaValue(this.input.filterParam));
      } else {
        labelValue = this.input.variable ? this.parent._checkFilter(this.input, this.getVariable(this.input.variable), this.input.filterParam) : '';
      }
      if(labelValue == undefined) return '';
      if(this.input.unit) {
        labelValue = `${labelValue} ${this.input.unit}`;
      }
      // @ts-ignore
      labelValue = this.$sanitize(labelValue, {
        allowedTags: ['span', 'b'],
        allowedAttributes: {
          'span': [ 'class' ]
        }
      });
      return labelValue.replace('&amp;', '&');
    },
    labelClass: function(): string {
      if(this.input.printable) return this.input.class;
      return `${this.input.class} d-flex justify-start`;
    }
  },
  watch: {
    resolvedFormulaValue() {
      if(this.input.storeFormulaValue) {
        const { prefix, key } = this.parent._getPrefixAndKey(this.input.variable);
        this.$set(this.parent._getVariable(prefix), key, this.resolvedFormulaValue);
      }
    }
  },
  methods: {
    retrieveFormulaValue: function(formulaString: string): string {
      const _variable = this.getVariable(this.input.variable);
      const resolvedValue = this.parent._resolveFormulaValue(formulaString, { _variable }, this.groupItemKey);
      try {
        return JSON.parse(resolvedValue);
      } catch (error) {
        return resolvedValue;
      }
    }
  }
})
